import { useTranslation } from 'react-i18next';
import { LuckyWheel } from './LuckyWheel';
import './LuckyWheel.css';

interface LuckyWheelNavButtonProps {
  onOpen: () => void;
  compact?: boolean;
}

export function LuckyWheelNavButton({ onOpen, compact = false }: LuckyWheelNavButtonProps) {
  const { t } = useTranslation('wheel');
  const ribbon = t('ribbonReady');

  return (
    <button
      type="button"
      className={`bottom-nav-wheel${compact ? ' bottom-nav-wheel-compact' : ''}`}
      onClick={onOpen}
      aria-label={t('openAria')}
    >
      <span className="lw-nav-ribbon">{ribbon}</span>
      <LuckyWheel variant="nav" />
    </button>
  );
}
